import { render, staticRenderFns } from "./write_comment.vue?vue&type=template&id=4652acfc&scoped=true&"
import script from "./write_comment.vue?vue&type=script&lang=js&"
export * from "./write_comment.vue?vue&type=script&lang=js&"
import style0 from "./write_comment.vue?vue&type=style&index=0&id=4652acfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652acfc",
  null
  
)

export default component.exports